var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThird(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#21AAE9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5326 31.1318C27.7102 27.581 28.953 24.8469 31.261 22.9294C33.6045 20.9765 36.676 20 40.4754 20C43.0675 20 45.2867 20.4616 47.1332 21.3848C48.9796 22.2725 50.3644 23.4976 51.2876 25.0599C52.2463 26.5868 52.7257 28.3267 52.7257 30.2796C52.7257 32.5166 52.1398 34.4163 50.968 35.9787C49.8318 37.5056 48.4647 38.5353 46.8668 39.0679V39.281C48.9263 39.9201 50.5242 41.0564 51.6605 42.6897C52.8322 44.3231 53.4181 46.4181 53.4181 48.9747C53.4181 51.1052 52.921 53.0049 51.9268 54.6738C50.968 56.3427 49.53 57.6565 47.6125 58.6152C45.7306 59.5384 43.4581 60 40.7949 60C36.7825 60 33.5158 58.988 30.9947 56.964C28.4736 54.9401 27.142 51.9574 27 48.016H34.2437C34.3147 49.7559 34.9006 51.1585 36.0013 52.2237C37.1376 53.2534 38.6822 53.7683 40.6352 53.7683C42.4461 53.7683 43.8309 53.2712 44.7896 52.277C45.7838 51.2472 46.281 49.9334 46.281 48.3356C46.281 46.2051 45.6063 44.6782 44.257 43.755C42.9077 42.8318 40.8127 42.3702 37.972 42.3702H36.4274V36.245H37.972C43.0142 36.245 45.5353 34.5584 45.5353 31.1851C45.5353 29.6582 45.0737 28.4687 44.1505 27.6165C43.2628 26.7643 41.9667 26.3382 40.2623 26.3382C38.5934 26.3382 37.2974 26.7998 36.3742 27.723C35.4865 28.6107 34.9716 29.747 34.8296 31.1318H27.5326Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThird);
export default __webpack_public_path__ + "static/media/third.cbbeb04af458dbab058bc75718250a46.svg";
export { ForwardRef as ReactComponent };